import React from "react";
import { Alert } from "@mui/material";
import { useLoyaltySettings } from "../../hooks/useLoyaltySettings";
import { isPurchasesMode, PURCHASES_RULES_BANNER } from "../../utils/loyaltyQualification";

export default function PurchasesModeRulesBanner({ brandName, sx = {} }) {
    const { qualificationMode } = useLoyaltySettings(brandName);
    if (!isPurchasesMode(qualificationMode)) return null;
    return (
        <Alert severity="info" sx={{ mb: 2, borderRadius: 2, ...sx }}>
            {PURCHASES_RULES_BANNER}
        </Alert>
    );
}
